import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import FullTable from "components/FullTable"
import numeral from 'numeral'
import { loadingStatus } from "actions"
import helpers from "helpers/helpers"
import getData from "helpers/submitData"
import ViewLead from 'containers/modals/viewLead'


class WebLeads extends Component {
	constructor(props) {
		super(props)
		this.state = {
			data: [],
			viewData: {},
			leadOpen: false,
			columns: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Type",
					accessor: "type",
					filterMethod: (f, r) => helpers.tableText(f, r, "type"),
				},
				{
					Header: "Interest",
					accessor: "interest",
					filterMethod: (f, r) => helpers.tableText(f, r, "interest"),
				},
				{
					Header: "First Name",
					accessor: "first_name",
					filterMethod: (f, r) => helpers.tableText(f, r, "first_name"),
				},
				{
					Header: "Last Name",
					accessor: "last_name",
					filterMethod: (f, r) => helpers.tableText(f, r, "last_name"),
				},
				{
					Header: "Zip",
					accessor: "zip",
					filterMethod: (f, r) => helpers.tableText(f, r, "zip"),
				},
				{
					Header: "Phone",
					accessor: "phone",
				},
				{
					Header: "Email",
					accessor: "email",
					filterMethod: (f, r) => helpers.tableText(f, r, "email"),
				},
				{
					Header: "Assigned",
					accessor: "assigned",
					filterMethod: (f, r) => helpers.tableText(f, r, "assigned"),
				},
				{
					Header: "Date",
					accessor: "date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY LT")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "View",
					accessor: "view",
				},
			],
		}
	}

	componentDidMount() {
		this.props.loadingStatus(true)
		this.pullData()
	}

	componentDidUpdate(prevProps) {
		if (!_.isEqual(prevProps, this.props)) {
			this.pullData()
		}
	}

	pullData = () => {
		getData("getLeads", { dates: this.props.currentDates, activeProperties: this.props.activeProperties })
			.then((resp) => {
				this.setState({ data: resp.data }, () => {
					//console.log(this.state)
				})
				this.props.loadingStatus(false)
			})
			.catch((e) => {
				console.log(e)
			})
	}

	buildTable = () => {
		var ret = []
		_.forEach(this.state.data, (v) => {
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let int
			let sps = ""
			_.forEach(v.emails_sent, (r) => {
				let sp = _.find(this.props.payload.users, { id: r })
				if (sp) {
					sps += `${sp.first} ${sp.last}, `
				}
			})
			sps = _.trim(sps, ", ")
			if (v.lot_id) {
				int = _.find(this.props.payload.exec.lots, { id: v.lot_id })
			} else {
				int = _.find(this.props.payload.public.floorplans, { id: v.floorplan })
			}
			let interest
			if (v.lot_id && int) {
				interest = int.address
			} else if(v.floorplan && int) {
				interest = int.name
			}
			let type
			if(v.lot_id) type = 'Lot'
			else if(v.floorplan) type = 'Floorplan'
			else type = 'Builder'
			let f = {
				community: property?.name || "",
				builder: builder ? builder.name : "",
				type,
				first_name: v.first_name,
				last_name: v.last_name,
				interest,
				zip: v.zip,
				phone: v.phone,
				email: v.email,
				assigned: sps,
				date: v.addedDate,
				view: (
					<button className="btn" onClick={() => this.setState({ viewData: v, leadOpen: true })}>
						View
					</button>
				),
			}
			ret.push(f)
		})

		ret = _.sortBy(ret, "date").reverse()
		return ret
	}

	render() {
		
		return (
			<div className="sales">
				<div className="imageGroup">
					<Title title="Web Leads" />
					<div className="content">
						<h2>Detailed List</h2>
						<FullTable
							data={this.buildTable()}
							columns={this.state.columns}
							name="webLeadsEntry__detailed"
							title="Web Leads"
							classNames="small"
							unset={['view']}
						/>
						<ViewLead open={this.state.leadOpen} onClose={() => this.setState({leadOpen: false})} data={this.state.viewData}  />
					</div>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
    return {
        currentDates: state.currentDates,
        compareDates: state.compareDates,
        payload: state.payload,
		activeProperties: state.activeProperties
    }
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(WebLeads)
